import { render } from "./cToast.vue?vue&type=template&id=2535b18c"
import script from "./cToast.vue?vue&type=script&lang=js"
export * from "./cToast.vue?vue&type=script&lang=js"

import exportComponent from "C:\\EPS_Code\\Clockwork_FrontandBack\\ClockWork.Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__